import React, { useState, useEffect } from 'react'
import { Grid, Typography } from "@material-ui/core";
import Item from "../Item/Item";
import ItemHorizontal from "../Item/ItemHorizontal";
import { Box } from "@material-ui/system";
import "./ItemList.css";
import {config} from "../../config/config";
// import ItemClass from '../utils/ItemClass/ItemClass';
import ApiQuery from "../utils/apiQuery/apiQuery";
import { CartContext } from '../CartContext/CartContext';
let apiQuery = new ApiQuery();
// let itemClass = new ItemClass();

// let dolar = config.DOLAR;


const ItemList = ({ products }) => {

  const [dolar, setDolar] = useState(0)
  const cartContext = React.useContext(CartContext);
	const itemClass = cartContext.itemClassContext;
  const productsList = products;
  
  useEffect(() => {
    let cancel = false;
    apiQuery.get(`/api/dolar`)
		.then((respuesta) => {
      if (cancel || !respuesta || !respuesta.dolar) return;
      setDolar(Number(respuesta.dolar));
		})
		.catch(() => {})
    return () => { 
      cancel = true;
    }
  }, [])


  return (
    <>
    {productsList.length
    ?
      <Grid container spacing={2} sx={{ marginTop: "0.1rem" }}>
        {productsList &&
          productsList.map((item) => (
            <Grid item key={item._id ? item._id : item.id} xs={12} sm={4} md={4} lg={3}>
              <Box  sx={{ width:"auto" }}>
                <div className="item">
                    <Item
                    product={item}
                    initial={item.stock ? 1 : item.stock}
                    sku={item._id ? item._id : item.id }
                    model={item.label ? item.label : ""}
                    name={`${
                      [item.name,
                        item.color,
                        item.linea,
                        item.presentacion,
                        `${(item.unidades!="0" && item.lista=="buloneria bremen") ? (`${item.unidades} unidades`) : ""}`,
                        `${item.contenido ? (""+item.contenido) : ""}`,
                        `${(item.lista == "einhell") ? (item.description || "") : ""}`,
                        `${(item.lista == "einhell") ? (item.medidas || "") : ""}`
                      ].filter(Boolean).join(" | ")
                    }`}
                    description={item.code}
                    categoria={item.categoria ? item.categoria : ""}
                    img={item.image}
                    // stock={item.stock ? item.stock : 100000}
                    stock={1000000}
                    price={itemClass.calcularPrecio(item,dolar)}
                  />

                </div>
                <div className="itemHorizontal">
                    <ItemHorizontal
                    product={item}
                    initial={item.stock ? 1 : item.stock}
                    sku={item._id ? item._id : item.id }
                    model={item.label ? item.label : ""}
                    name={`${
                      [item.name,
                        item.color,
                        item.linea,
                        item.presentacion,
                        `${(item.unidades!="0" && item.lista=="buloneria bremen") ? (`${item.unidades} unidades`) : ""}`,
                        `${item.contenido ? (""+item.contenido) : ""}`,
                        `${(item.lista == "einhell") ? (item.description || "") : ""}`,
                        `${(item.lista == "einhell") ? (item.medidas || "") : ""}`
                      ].filter(Boolean).join("|")
                    }`}
                    description={item.code}
                    img={item.image}
                    // stock={item.stock ? item.stock : 100000}
                    stock={1000000}
                    // price={item.price ? ccyFormat(item.price) : (item.usd ? ccyFormat(item.usd*dolar) : "") }
                    // price={calcularPrecio(item) }
                    price={itemClass.calcularPrecio(item,dolar)}
                  />
                </div>

              </Box>
            </Grid>
          ))}
      </Grid>
      :
      ( productsList.length !== 0 ? <>
        <Box sx={{marginTop:"2rem"}}>
          <Typography variant="h4">
            Sin resultados
          </Typography>
        </Box>
      
      </>:<></>

      )
      }
    </>
  );
};

export default ItemList;
